import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TOGGLE_STARRED_APPLICATION } from "@Broker/@Modules/clients/board/store/board-mutations";
import { SYNCHRONIZE_LINKED_APPLICATION } from "@Broker/@Modules/clients/board/store/board-actions";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import InlinePrompt from "@Shared/components/general/inline-prompt";
// import InlineLoader from "@Shared/components/general/inline-loader";
import { DELETE_APPLICATION } from "@Broker/@Modules/clients/applications/application/store/application-actions";
import { showToast } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LinkedApplicationItem",
  components: {
    InlinePrompt
    // InlineLoader
  },
  props: {
    applicationId: {
      type: String,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    createdAt: {
      type: Date,
      default: "",
      required: true
    },
    propertyAddress: {
      type: String,
      default: ""
    },
    mortgageAmount: {
      type: String,
      default: ""
    },
    totalLoanAmount: {
      type: String,
      default: ""
    },
    coapps: {
      type: String,
      default: ""
    },
    agentUsername: {
      type: String,
      default: ""
    },
    filogixId: {
      type: String,
      default: ""
    },
    clientUsername: {
      type: String,
      default: ""
    },
    allowDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      deletingApplication: {},
      syncingApplication: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", {
    starredApplicationId(state) {
      return state.clientProfiles.byId[this.clientProfileId].starredApplicationId;
    }
  })), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    disablePinApplication() {
      return this.starredApplicationId && !this.isApplicationPinned;
    },
    isApplicationPinned() {
      return this.starredApplicationId === this.applicationId;
    },
    getTooltipTitle() {
      if (!this.starredApplicationId) return this.$t("client-profile.actions.pinApplication");
      return this.isApplicationPinned ? this.$t("client-profile.actions.unpinApplication") : this.$t("client-profile.messages.thereIsPinnedApplication");
    },
    href() {
      const {
        clientUsername,
        agentUsername,
        applicationId
      } = this;
      return {
        name: "application",
        params: {
          clientUsername,
          agentUsername,
          applicationId
        }
      };
    },
    localMortgageAmount() {
      return this.totalLoanAmount || this.mortgageAmount;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations("BoardStore", [TOGGLE_STARRED_APPLICATION])), mapActions("ApplicationStore", [DELETE_APPLICATION])), mapActions("BoardStore", [SYNCHRONIZE_LINKED_APPLICATION])), {}, {
    pinApplication() {
      this.TOGGLE_STARRED_APPLICATION({
        applicationId: this.applicationId,
        clientProfileId: this.clientProfileId
      });
      this.$emit("save");
    },
    async copyApplication() {
      const {
        applicationId,
        agentUsername,
        clientUsername,
        propertyAddress
      } = this;
      this.$emit("copy-application", {
        applicationId,
        agentUsername,
        clientUsername,
        propertyAddress: propertyAddress || ""
      });
    },
    async removeApplication() {
      this.$set(this.deletingApplication, this.applicationId, true);
      if (this.isApplicationPinned) {
        this.TOGGLE_STARRED_APPLICATION({
          clientProfileId: this.clientProfileId
        });
        this.$nextTick(() => {
          this.$emit("save");
        });
      }
      await this.DELETE_APPLICATION({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.$set(this.deletingApplication, this.applicationId, false);
    },
    handleOpenDuplicateModal() {
      this.$emit("duplicate-modal-opened");
    },
    async handleSyncApplication() {
      const {
        clientProfileId,
        applicationId
      } = this;
      this.syncingApplication = true;
      const {
        succeeded
      } = await this.SYNCHRONIZE_LINKED_APPLICATION({
        clientProfileId,
        applicationId
      });
      this.syncingApplication = false;
      if (succeeded) showToast("success", "linkedApplicationSynchronized");
    }
  })
});